<template>
    <figure
        :class="`ui-avatar rounded-circle overflow-hidden ${size}`"
    >
        <img
            v-if="src"
            :src="src"
            loading="lazy"
            class="object-fit"
        >
        <span
            v-else
            class="initials font-weight-semi-bold text-smaller"
        >
            {{ getInitials }}
        </span>
    </figure>
</template>

<script>
    import initials from 'initials';

    export default {
        name: 'UiAvatar',
        props: {
            name: {
                type: String,
                default: null,
            },
            size: {
                type: String,
                default: null,
            },
            src: {
                type: String,
                default: null,
            },
        },
        computed: {
            getInitials() {
                return initials(this.name);
            },
        }
    };
</script>

<style lang="scss" scoped>
    .ui-avatar {
        position: relative;
        width: 32px;
        height: 32px;

        @include respond-to(lg) {
            width: 48px;
            height: 48px;
        }

        &.small {
            width: 24px;
            height: 24px;

            @include respond-to(lg) {
                width: 32px;
                height: 32px;
            }
        }

        &.medium {
            width: 64px;
            height: 64px;

            @include respond-to(lg) {
                width: 96px;
                height: 96px;
            }
        }

        &.large {
            width: 96px;
            height: 96px;

            @include respond-to(lg) {
                width: 128px;
                height: 128px;
            }
        }

        .initials {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
</style>
